import Pubnub from 'pubnub';


export const pubnub = (uuid) => {
  return new Pubnub({
    publishKey: "pub-c-1cc624a7-268f-479e-8cb2-0e36e76d313a",
    subscribeKey: "sub-c-fbf211c1-35fa-415f-808a-7c74662eb329",
    uuid// this would be the user's database ID
  })
};